import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft, Maximize2 } from 'lucide-react'
import useAuthStore from '../../store/authStore.js'
import { useLanguage } from '../../i18n/index.jsx'
import './SimpleLayout.css'

interface SimpleLayoutProps {
  children: React.ReactNode
}

export default function SimpleLayout({ children }: SimpleLayoutProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { setSimpleMode } = useAuthStore()
  const { t } = useLanguage()

  const isHome = location.pathname === '/simple'

  const handleSwitchToFull = async () => {
    await setSimpleMode(false)
    navigate('/')
  }

  const handleBack = () => {
    navigate('/simple')
  }

  return (
    <div className="simple-layout">
      <a href="#main-content" className="skip-link">
        {t('skipToContent')}
      </a>
      <header className="simple-topbar">
        <div className="simple-topbar-left">
          {!isHome && (
            <button className="simple-back-btn" onClick={handleBack} aria-label={t('back')}>
              <ArrowLeft size={20} />
            </button>
          )}
        </div>

        <div className="simple-topbar-center">
          <span className="simple-logo">Brighella</span>
        </div>

        <div className="simple-topbar-right">
          <button
            className="simple-topbar-btn"
            onClick={handleSwitchToFull}
            title={t('switchToFull')}
            aria-label={t('switchToFull')}
          >
            <Maximize2 size={16} />
          </button>
        </div>
      </header>

      <main id="main-content" tabIndex={-1} className="simple-content">
        {children}
      </main>
    </div>
  )
}
